import React from "react";

const EnvelopeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.76891 5.70379C2.69235 6.18823 2 7.25902 2 8.43955V16.9998C2 18.6566 3.34315 19.9998 5 19.9998H19C20.6569 19.9998 22 18.6566 22 16.9998V8.43955C22 7.25902 21.3076 6.18823 20.2311 5.70379L13.2311 2.55379C12.4482 2.20147 11.5518 2.20147 10.7689 2.55379L3.76891 5.70379ZM6.5547 8.16774C6.09517 7.86139 5.4743 7.98557 5.16795 8.44509C4.8616 8.90462 4.98577 9.52549 5.4453 9.83184L10.3359 13.0922C11.3436 13.764 12.6564 13.764 13.6641 13.0922L18.5547 9.83184C19.0142 9.52549 19.1384 8.90462 18.8321 8.44509C18.5257 7.98557 17.9048 7.86139 17.4453 8.16774L12.5547 11.4281C12.2188 11.6521 11.7812 11.6521 11.4453 11.4281L6.5547 8.16774Z"
        fill="#5243FA"
      />
    </svg>
  );
};

export default EnvelopeIcon;
